import React from 'react'
import Contactbanner from '../Mencontactus/Contactbanner'
import Bredcrumb from '../Bredcrumb/Main'
import Img from '../../assets/images/background/banner-image-4.webp'

function Main() {
  return (
    <>
      <Bredcrumb title="" subtitle="Contact Us" Img={Img} />
      <Contactbanner />
    </>
  )
}

export default Main
